<template>
<span v-if="field">
  <span :class="icon"></span>

  <span class="value" v-if="field.minValue">{{ $t("fieldMin") }}&nbsp;{{ field.minValue }}</span>
  <span class="value" v-else-if="field.maxValue">{{ $t("fieldMax") }}&nbsp;{{ field.maxValue }}</span>
  <br>

  <span class="key">{{ label }}</span>
</span>

</template>

<script>
export default {
  name: "IconField",

  props: [
    "label",
    "icon",
    "field"
  ]
}
</script>
